export enum RevenueType {
  GOAL_WORST = 0,
  GOAL_BEST = 1,
  REAL = 2,
}
